// Events async load banner content
$(function () {
    $(document).on('click', '.cartGeniusContainer .viewMore', function (e) {
        e.stopPropagation();
        $('.cartGenius--mobile.mobile-only').removeClass('deactivate');
        $('.cartGeniusContainer .seeLess').removeClass('hide');
        $(this).addClass('hide');
        $('.cartGenius--mobile .arrow').css('transform', 'rotate(180deg)');
        _push_custom_event_to_GA4('cart_genius_click', 'description', 'tile | view more - mobile only');
    });

    $(document).on('click', '.cartGeniusContainer .seeLess', function (e) {
        e.stopPropagation();
        $('.cartGenius--mobile.mobile-only').addClass('deactivate');
        $('.cartGeniusContainer .viewMore').removeClass('hide');
        $(this).addClass('hide');
        $('.long-title').css('display', 'none');
        $('.cartGenius--mobile .arrow').css('transform', 'rotate(0deg)');
        _push_custom_event_to_GA4('cart_genius_click', 'description', 'tile | see less - mobile only');
    });

    $(document).on('click', '.cartGeniusContainer .cartGenius--banner--text .sub-title button', function (e) {
        e.stopPropagation();
    });

    $(document).on('click', '.cartGeniusContainer', function (e) {
        var $target = $(e.target);

        // Ignore clicks on interactive elements
        if ($target.closest('a, button, input, textarea, select, [role="button"], .cartGenius-submit, .overlayServiceBox').length) {
            return;
        }

        if ($('.cartGeniusContainer .overlayServiceBox').length) {
            return;
        }

        $('.cartGeniusContainer .cartGenius-submit').trigger('click');
    });

    $(document).on('click', '.cartGenius-submit', function () {
        _push_custom_event_to_GA4('cart_genius_click', 'description', 'tile | view my cart genius');
    });

    $(document).on('click', '.tooltip.sign-in', function () {
        pushDataLayerSignInOrSignUpCartGenius('tooltip', 'sign-in');
    });

    $(document).on('click', '.tooltip.create.account', function () {
        pushDataLayerSignInOrSignUpCartGenius('tooltip', 'create account');
    });

    $(document).on('click', '.tile.sign-in', function () {
        pushDataLayerSignInOrSignUpCartGenius('tile', 'sign-in');
    });

    $(document).on('click', '.tile.create.account', function () {
        pushDataLayerSignInOrSignUpCartGenius('tile', 'create account');
    });

    function pushDataLayerSignInOrSignUpCartGenius(from, action) {
        let description = from + ' | ' + action
        _push_custom_event_to_GA4('cart_genius_click', 'description', description);
        if (action === 'sign-in') {
            _push_custom_event_to_GA4('login_intent', 'origin', 'cart genius');
        } else if (action === 'create account') {
            _push_custom_event_to_GA4('sign_up_intent', 'origin', 'cart genius');
        }
    }
    // Automatically launch an asynchronous load of the cart genius banner
    CartGeniusBanner.asyncLoadCartGeniusCallback($('#cart-genius-main'));
});